// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Printf from "bs-platform/lib/es6/printf.js";

function stringToDirection(s) {
  switch (s) {
    case "above" :
        return /* Above */0;
    case "below" :
        return /* Below */1;
    case "left" :
        return /* Left */2;
    case "right" :
        return /* Right */3;
    default:
      return ;
  }
}

function dirToString(d) {
  switch (d) {
    case /* Above */0 :
        return "above";
    case /* Below */1 :
        return "below";
    case /* Left */2 :
        return "left";
    case /* Right */3 :
        return "right";
    
  }
}

var name = "edge";

function render(e) {
  var match = e.curve;
  var tmp;
  if (match) {
    var f = function (d) {
      switch (d) {
        case /* Above */0 :
            return "above";
        case /* Below */1 :
            return "below";
        case /* Left */2 :
            return "left";
        case /* Right */3 :
            return "right";
        
      }
    };
    tmp = Curry._2(Printf.sprintf(/* Format */{
              _0: {
                TAG: /* String_literal */11,
                _0: "~(",
                _1: {
                  TAG: /* String */2,
                  _0: /* No_padding */0,
                  _1: {
                    TAG: /* String_literal */11,
                    _0: ", ",
                    _1: {
                      TAG: /* String */2,
                      _0: /* No_padding */0,
                      _1: {
                        TAG: /* Char_literal */12,
                        _0: /* ")" */41,
                        _1: /* End_of_format */0
                      }
                    }
                  }
                }
              },
              _1: "~(%s, %s)"
            }), f(match._0), f(match._1));
  } else {
    tmp = "--";
  }
  var s = Curry._5(Printf.sprintf(/* Format */{
            _0: {
              TAG: /* Char_literal */12,
              _0: /* "(" */40,
              _1: {
                TAG: /* String */2,
                _0: /* No_padding */0,
                _1: {
                  TAG: /* String_literal */11,
                  _0: ") draw=",
                  _1: {
                    TAG: /* String */2,
                    _0: /* No_padding */0,
                    _1: {
                      TAG: /* String_literal */11,
                      _0: " (",
                      _1: {
                        TAG: /* String */2,
                        _0: /* No_padding */0,
                        _1: {
                          TAG: /* String_literal */11,
                          _0: ") ",
                          _1: {
                            TAG: /* String */2,
                            _0: /* No_padding */0,
                            _1: {
                              TAG: /* String_literal */11,
                              _0: " (",
                              _1: {
                                TAG: /* String */2,
                                _0: /* No_padding */0,
                                _1: {
                                  TAG: /* Char_literal */12,
                                  _0: /* ")" */41,
                                  _1: /* End_of_format */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            },
            _1: "(%s) draw=%s (%s) %s (%s)"
          }), e.edge_id, e.draw ? "yes" : "no", e.scoord, tmp, e.tcoord);
  return React.createElement("div", {
              key: e.edge_id
            }, s);
}

var Edge = {
  name: name,
  render: render
};

function select(selectedDir, dirOnChange) {
  var f = function (lineOrBezier) {
    if (lineOrBezier !== undefined) {
      return dirToString(lineOrBezier);
    } else {
      return "-";
    }
  };
  var opt = function (c) {
    return React.createElement("option", {
                value: f(c)
              }, f(c));
  };
  return React.createElement("select", {
              value: f(selectedDir),
              onChange: dirOnChange
            }, opt(undefined), opt(/* Above */0), opt(/* Below */1), opt(/* Left */2), opt(/* Right */3));
}

var initState = {
  name: "",
  draw: true,
  sname: "",
  tname: "",
  sdir: undefined,
  tdir: undefined
};

function Edge$Add(Props) {
  var updater = Props.updater;
  var match = React.useState(function () {
        return initState;
      });
  var setState = match[1];
  var state = match[0];
  var handleName = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (st) {
                  return {
                          name: a,
                          draw: st.draw,
                          sname: st.sname,
                          tname: st.tname,
                          sdir: st.sdir,
                          tdir: st.tdir
                        };
                }));
  };
  var handleSname = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (st) {
                  return {
                          name: st.name,
                          draw: st.draw,
                          sname: a,
                          tname: st.tname,
                          sdir: st.sdir,
                          tdir: st.tdir
                        };
                }));
  };
  var handleTname = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (st) {
                  return {
                          name: st.name,
                          draw: st.draw,
                          sname: st.sname,
                          tname: a,
                          sdir: st.sdir,
                          tdir: st.tdir
                        };
                }));
  };
  var drawOnChange = function (e) {
    e.preventDefault();
    var draw = e.target.value;
    return Curry._1(setState, (function (s) {
                  if (draw === "yes") {
                    return {
                            name: s.name,
                            draw: true,
                            sname: s.sname,
                            tname: s.tname,
                            sdir: s.sdir,
                            tdir: s.tdir
                          };
                  } else {
                    return {
                            name: s.name,
                            draw: false,
                            sname: s.sname,
                            tname: s.tname,
                            sdir: s.sdir,
                            tdir: s.tdir
                          };
                  }
                }));
  };
  var sdirOnChange = function (e) {
    e.preventDefault();
    var dirStr = e.target.value;
    return Curry._1(setState, (function (s) {
                  var d = stringToDirection(dirStr);
                  var match = d !== undefined ? [
                      d,
                      s.tdir
                    ] : [
                      undefined,
                      undefined
                    ];
                  return {
                          name: s.name,
                          draw: s.draw,
                          sname: s.sname,
                          tname: s.tname,
                          sdir: match[0],
                          tdir: match[1]
                        };
                }));
  };
  var tdirOnChange = function (e) {
    e.preventDefault();
    var dirStr = e.target.value;
    return Curry._1(setState, (function (s) {
                  var d = stringToDirection(dirStr);
                  var match = d !== undefined ? [
                      s.sdir,
                      d
                    ] : [
                      undefined,
                      undefined
                    ];
                  return {
                          name: s.name,
                          draw: s.draw,
                          sname: s.sname,
                          tname: s.tname,
                          sdir: match[0],
                          tdir: match[1]
                        };
                }));
  };
  var handleSubmit = function (e) {
    e.preventDefault();
    var match = state.sdir;
    var match$1 = state.tdir;
    var curve = match !== undefined && match$1 !== undefined ? /* Bezier */({
          _0: match,
          _1: match$1
        }) : /* Line */0;
    Curry._5(updater, state.name, state.draw, state.sname, state.tname, curve);
    return Curry._1(setState, (function (param) {
                  return initState;
                }));
  };
  return React.createElement("div", {
              className: "add edge"
            }, React.createElement("form", {
                  onSubmit: handleSubmit
                }, "Edge: ", "name=", React.createElement("input", {
                      className: "input-name",
                      name: "name",
                      type: "text",
                      value: state.name,
                      onChange: handleName
                    }), " draw:", React.createElement("select", {
                      value: state.draw ? "yes" : "no",
                      onChange: drawOnChange
                    }, React.createElement("option", {
                          value: "yes"
                        }, "yes"), React.createElement("option", {
                          value: "no"
                        }, "no")), ", start=", React.createElement("input", {
                      className: "input-name",
                      name: "sname",
                      type: "text",
                      value: state.sname,
                      onChange: handleSname
                    }), select(state.sdir, sdirOnChange), ", end=", React.createElement("input", {
                      className: "input-name",
                      name: "tname",
                      type: "text",
                      value: state.tname,
                      onChange: handleTname
                    }), select(state.tdir, tdirOnChange), React.createElement("input", {
                      type: "submit",
                      value: "add/modify",
                      onClick: (function (param) {
                          
                        })
                    })));
}

var Add = {
  select: select,
  initState: initState,
  make: Edge$Add
};

export {
  stringToDirection ,
  dirToString ,
  Edge ,
  name ,
  render ,
  Add ,
  
}
/* react Not a pure module */
